// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"945":"dashboard","966":"login"}[chunkId] + "." + {"945":"30ac7c52","966":"f7659513"}[chunkId] + ".css";
};